import { GalleryWidgetModel } from '../models/GalleryWidgetModel';
import { ImageGallery } from './ImageGallery';
import { previewScrollbar } from 'shared-widget-components/src/components/preview/previewScrollbar';

export interface WidgetProps {
  formData: GalleryWidgetModel;
  languageCode: string;
}
/**
 * @description This component is displayed as a preview in the Admin editor and as a widget in the webshop.
 * @param0 formData GalleryWidgetModel; The data of the widget.
 * @param1 languageCode string; The language code represents the language that is currently used.
 * @returns {JSX.Element} The GalleryComponent widget
 */

export const GalleryComponent = ({ formData, languageCode }: WidgetProps) => {
  const getLanguageContent = () => {
    if (formData.title && formData.title[languageCode]) {
      const languageConent = formData.title[languageCode];
      return languageConent;
    }

    if (formData.title) return formData.title['hu'];
    return { title: '' };
  };

  return (
    <div
      className='flex justify-center min-[350px]:p-2 md:px-8 relative min-[350px]:items-start sm:items-center mx-auto w-full previewScrollbar h-full min-[350px]:overflow-y-auto sm:overflow-hidden min-[350px]:py-4 md:py-6 lg:py-10'
      style={{ background: formData.backgroundColor }}
    >
      <style>{previewScrollbar}</style>

      <div className='max-w-[1240px] min-[350px]:px-2 md:px-2  justify-center w-full items-center '>
        <h1 className='font-body font-bold min-[350px]:text-[20px] md:text-[28px] mb-2' style={{ color: formData.textColor }}>
          {getLanguageContent().title}
        </h1>
        <ImageGallery formData={formData} />
      </div>
    </div>
  );
};
